import { Icon, IconProps } from '@chakra-ui/react'

export default function SettingsCogIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53204 1.99805C8.81343 1.99805 9.06452 2.17473 9.15964 2.43956L9.49844 3.38329C9.55222 3.53169 9.6566 3.65639 9.79323 3.73544L10.7983 4.31568C10.9348 4.39443 11.0948 4.42231 11.2498 4.39438L12.2369 4.2163C12.5141 4.1659 12.793 4.2951 12.9339 4.53911L13.4674 5.45949C13.6086 5.70283 13.5819 6.0086 13.4007 6.22381L12.7531 6.98946C12.6511 7.10985 12.5951 7.26251 12.5951 7.4203V8.58079C12.5951 8.73858 12.6511 8.89124 12.7531 9.01163L13.4007 9.77729C13.5819 9.99249 13.6086 10.2983 13.4674 10.5416L12.9339 11.462C12.7931 11.7057 12.5145 11.8349 12.2376 11.7848L11.2505 11.6067C11.0954 11.5788 10.9355 11.6067 10.799 11.6854L9.7939 12.2657C9.65727 12.3447 9.55289 12.4694 9.49911 12.6178L9.1603 13.5615C9.06511 13.8266 8.81368 14.0033 8.53204 14.003H7.46493C7.18354 14.003 6.93245 13.8264 6.83733 13.5615L6.49853 12.6178C6.44476 12.4696 6.34067 12.345 6.2044 12.2657L5.19865 11.6854C5.06217 11.6067 4.90221 11.5788 4.74713 11.6067L3.76005 11.7848C3.48287 11.8352 3.20392 11.706 3.0631 11.462L2.52954 10.5416C2.38834 10.2983 2.41502 9.99249 2.59624 9.77729L3.24384 9.01163C3.34584 8.89124 3.40184 8.73858 3.4019 8.58079V7.4203C3.40184 7.26251 3.34584 7.10985 3.24384 6.98946L2.60291 6.22381C2.42169 6.0086 2.39501 5.70283 2.53621 5.45949L3.06977 4.53911C3.2105 4.29537 3.4891 4.16621 3.76606 4.2163L4.75313 4.39438C4.90821 4.42231 5.06817 4.39443 5.20466 4.31568L6.21041 3.73544C6.34667 3.65613 6.45077 3.5315 6.50453 3.38329L6.84334 2.43956C6.9377 2.17679 7.18574 2.0006 7.46493 1.99805H8.53204Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8.00011"
        cy="8.00011"
        r="1.8341"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
